






































































































import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class BillOfLading extends Vue {
    private eventEmit = {
        eventAddRow: 'eventAddRow',
        eventRemoveRow: 'eventRemoveRow'
    };

    @Prop({ default: () => [] })
    private listLadings!: any[];

    @Prop()
    private checkValid!: any;

    private limit = 100;

    private async addRow() {
        if (this.listLadings.length >= this.limit) {
            return false;
        }
        this.$emit(this.eventEmit.eventAddRow, null);
    }

    private async removeRow(id: string) {
        this.$emit(this.eventEmit.eventRemoveRow, id);
    }
}
